import { useRouter } from 'next/router';

import { CONDUCTOR_RELEASES, UNSUPPORTED_CHATBOT_LOCALES } from '../constants';
import { useStore } from '../zustand/stores';

export const useIsAnonymousAiChatbotEnabled = () => {
  const releases = useStore((state) => state.releasesSlice);
  const { locale } = useRouter();

  if (UNSUPPORTED_CHATBOT_LOCALES.includes(locale as string)) {
    return false;
  }

  return (
    releases[CONDUCTOR_RELEASES.ENABLE_ANONYMOUS_AI_CHATBOT] === 'B'
  );
};
